import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { FetchDiagnosticsError, FetchDiagnosticsResponse } from '@models/diagnostics/FetchDiagnostics';
import { secondsToMillis } from '@utils/millis';
import { fetchDiagnostics } from '@repository/diagnosticsRepository';

const useFetchDiagnostics = () => {
    return useQuery<FetchDiagnosticsResponse, FetchDiagnosticsError>({
        queryKey: [QueryKey.Diagnostics],
        queryFn: ({ signal }) => fetchDiagnostics({ signal }),
        staleTime: secondsToMillis(30),
    });
};

export default useFetchDiagnostics;
